export const getLocalStorageValue = (key, parse = false) => {
	if (key) {
		try {
			const item = window?.localStorage.getItem(key);
			return item ? (parse ? JSON.parse(item) : item) : null;
		} catch (error) {
			console.log(error);
		}
	}
	return null;
};

export const setLocalStorageValue = (key, value) => {
	try {
		window?.localStorage.setItem(
			key,
			typeof value === "object" ? JSON.stringify(value) : value
		);
	} catch (error) {
		// silently fail to match getLocalStorageValue pattern
	}
};

export const removeLocalStorageValue = (key) => {
	try {
		window.localStorage.removeItem(key);
	} catch (error) {
		console.error(error);
	}
};
